import { Layout } from "antd";
import { MenuLateral } from "shared/components";
import "./Layout.scss";
import { isMobile } from "react-device-detect";

const { Content } = Layout;
const NewLayout: React.FC<{ children?: React.ReactNode }> = (props) => {
  const { children } = props;

  return (
    <Layout className={`new-layout ${isMobile ? "is-mobile" : "is-web"}`}>
      <MenuLateral />
      <Content className={isMobile ? "mobile-content" : ""}>
        <div className="mobile-content-centralizado">{children}</div>
      </Content>
    </Layout>
  );
};

export default NewLayout;
